export { default as CurpInfo } from './curp-info';
